export const products = [
  {
    id: 'f1',
    name: 'The Berry Blast Flight',
    type: 'Flavor Flight',
    category: 'flights',
    price: 48,
    description: '4 pints of our finest berry creations: Strawberry Balsamic, Raspberry Truffle, Triple Blackberry, and Wild Blueberry.',
    image: 'https://images.unsplash.com/photo-1557142046-c704a3adf364?auto=format&fit=crop&q=80&w=800',
    tag: 'Best Seller',
    ingredients: 'Organic Berries, Grass-fed Cream, Cane Sugar, Sea Salt',
    stock: 12
  },
  {
    id: 'b1',
    name: 'Vanilla Bean Dream Box',
    type: 'Gift Box',
    category: 'gift-boxes',
    price: 65,
    description: '6 pints of exquisite vanilla variants sourced globally. Includes specialized tasting spoons and flavor notes.',
    image: 'https://images.unsplash.com/photo-1570197781417-0a5237700200?auto=format&fit=crop&q=80&w=800',
    tag: 'Perfect Gift',
    ingredients: 'Madagascar Vanilla, Tahitian Vanilla, Mexican Vanilla, Organic Cream',
    stock: 8
  },
  {
    id: 'f2',
    name: 'Arctic Assortment',
    type: 'Flavor Flight',
    category: 'flights',
    price: 52,
    description: 'A refreshing mix of our coldest hits: Mint Chip, Polar Peppermint, Glacier Sea Salt Caramel, and Frosty Lemon.',
    image: 'https://images.unsplash.com/photo-1563805042-7684c8a9e9cb?auto=format&fit=crop&q=80&w=800',
    ingredients: 'Peppermint Oil, 70% Cacao Chips, Sea Salt, Lemon Zest',
    stock: 15
  },
  {
    id: 'b2',
    name: 'Ultimate Party Cooler',
    type: 'Party Bundle',
    category: 'bundles',
    price: 120,
    description: '12 assorted pints packed in our reusable premium cooler. Perfect for gatherings. Guaranteed frozen for 48 hours.',
    image: 'https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?auto=format&fit=crop&q=80&w=800',
    tag: 'Value',
    ingredients: 'Assorted seasonal flavors',
    stock: 5
  },
  {
    id: 'f3',
    name: 'Midnight Orchard',
    type: 'Flavor Flight',
    category: 'flights',
    price: 50,
    description: 'Deep, dark fruit profiles: Black Cherry, Plum Cardamom, Spiced Pear, and Roasted Fig.',
    image: 'https://images.unsplash.com/photo-1488900128323-21503983a07e?auto=format&fit=crop&q=80&w=800',
    ingredients: 'Roasted Figs, Black Cherries, Cardamom, Organic Milk',
    stock: 10
  }
];

export const reviews = [
  {
    id: 1,
    name: 'Sarah M.',
    location: 'Chicago, IL',
    text: 'The dry ice packaging is no joke! My Berry Blast flight arrived perfectly frozen despite a heatwave. The flavors are intensely good.',
    rating: 5
  },
  {
    id: 2,
    name: 'James T.',
    location: 'Austin, TX',
    text: 'Sent the Vanilla Dream Box to my mom for her birthday. She loved the unboxing experience almost as much as the ice cream.',
    rating: 5
  },
  {
    id: 3,
    name: 'Elena R.',
    location: 'Seattle, WA',
    text: 'Finally, a dessert delivery that understands cold-chain logistics. The texture was exactly as if I bought it from a local parlor.',
    rating: 4
  }
];

export const faqs = [
  {
    question: 'How does preorder and shipping work?',
    answer: 'We batch our production for maximum freshness. Orders placed by Wednesday 11:59 PM EST ship the following Monday via overnight or 2-day air, packed with dry ice.'
  },
  {
    question: 'Is the dry ice safe?',
    answer: 'Yes! We include clear handling instructions. The dry ice ensures your desserts remain at a deeply frozen -109°F during transit. Please do not touch it with bare hands.'
  },
  {
    question: 'What are your delivery zones?',
    answer: 'We currently ship to the contiguous 48 United States. We cannot ship to PO Boxes, APO/FPO addresses, or internationally at this time due to cold-chain restrictions.'
  }
];